/**
 * Gestisce la lingua e le traduzioni
 */
export default class NwLang {
    constructor() {
        this.currentLang = 'it';
    }

    /**
     * Configura l'oggetto con le frase di traduzione indicate
     * @param phrases (Object): Oggetto contentente le traduzioni con la seguente struttura:
     *  { 'it': {
     *          'phrase_key': 'phrase_it',
     *          ...
     *      },
     *    'en': {
     *          'phrase_key': 'phrase_en',
     *          ...
     *      },
     *     ...
     *  }
     */
    configure(phrases) {
        this.phrases = phrases;
    }

    /**
     * Restituisce la frase tradotta associata alla chiave indicata,
     * o la chiave stessa se la traduzione non è disponibile
     * @param key (string): La chiave della frase di cui si vuole la traduzione
     * @returns string
     */
    get(key) {
        if (!this.phrases) {
            throw new Error("Classe NwLang non configurata");
        }

        var lang_phrases = this.phrases[this.currentLang];
        if (lang_phrases && lang_phrases[key]) {
            return lang_phrases[key];
        }

        return key;
    }

    _(key) {
        return this.get(key);
    }
}


/** WEBPACK FOOTER **
 ** ./assets/scripts/src/core/lang.js
 **/